module.exports = __webpack_public_path__ + "static/media/icon-shown-ready.f3199b39.svg";